import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import GlobaleSuche from './GlobaleSuche';

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isActive = (path) =>
    path === '/' ? location.pathname === '/' : location.pathname.startsWith(path);

  const isAdmin = user?.rolle === 'admin';
  const isAdminOrSchwimmadmin = ['admin', 'schwimmadmin'].includes(user?.rolle);

  // Nach Arbeitsbereichen gruppiert: 20 gleichwertige Einträge untereinander
  // lassen sich nicht überfliegen.
  const navGruppen = [
    { titel: null, eintraege: [
      { path: '/',              label: 'Dashboard',            icon: '⊞' },
    ] },
    { titel: 'Kinder & Gruppen', eintraege: [
      { path: '/warteliste',    label: 'Warteliste',           icon: '≡' },
      { path: '/gruppen',       label: 'Ausbildungsgruppen',   icon: '🏊' },
      ...(isAdminOrSchwimmadmin ? [
        { path: '/leistungsgruppen', label: 'Leistungsgruppen', icon: '🏅' },
      ] : []),
      { path: '/schwimmer',     label: 'Schwimmer',            icon: '👶' },
      { path: '/uebungen',      label: 'Prüfungsanforderungen', icon: '📋' },
    ] },
    ...(isAdminOrSchwimmadmin ? [{ titel: 'Verein & Abrechnung', eintraege: [
      { path: '/team',          label: 'Team',                 icon: '🧑‍🏫' },
      { path: '/rollen',        label: 'Rollen & Vergütung',   icon: '💶' },
      { path: '/stunden',       label: 'Trainer-/Helferstunden', icon: '⏱' },
      { path: '/bahnen',        label: 'Bahnenstunden',        icon: '🏊‍♀️' },
    ] }] : []),
    { titel: 'Auswertung & Kontakt', eintraege: [
      { path: '/statistik',     label: 'Statistik',            icon: '📊' },
      { path: '/kontakt',       label: 'Kontaktanfragen',      icon: '✉' },
      { path: '/probetraining', label: 'Probetraining',        icon: '◎' },
    ] },
    { titel: 'Website & E-Mail', eintraege: [
      { path: '/angebote',      label: 'Angebote',             icon: '🎯' },
      { path: '/angebot-typen', label: 'Angebot-Typen',        icon: '🏷' },
      { path: '/email-vorlagen',label: 'E-Mail-Vorlagen',      icon: '✉️' },
      { path: '/email-archiv',  label: 'E-Mail-Archiv',        icon: '📬' },
      { path: '/kacheln',       label: 'Kacheln',              icon: '▦' },
      { path: '/bilder',        label: 'Bildbibliothek',       icon: '🖼' },
    ] },
    { titel: 'Verwaltung', eintraege: [
      ...(isAdminOrSchwimmadmin ? [{ path: '/benutzer', label: 'Benutzer', icon: '👤' }] : []),
      { path: '/einstellungen', label: 'Einstellungen',        icon: '⚙' },
    ] },
  ];

  return (
    <div className="layout">
      {open && <div className="sidebar-overlay" onClick={() => setOpen(false)} />}

      <nav className={`sidebar${open ? ' open' : ''}`}>
        <div className="sidebar-brand">
          <span className="sidebar-logo">🏊</span>
          <span className="sidebar-title">SwimDesk</span>
          <button className="sidebar-close-btn" onClick={() => setOpen(false)}>×</button>
        </div>

        <ul className="sidebar-nav">
          {navGruppen.filter(g => g.eintraege.length > 0).map((gruppe, i) => (
            <React.Fragment key={gruppe.titel || `start-${i}`}>
              {gruppe.titel && <li className="sidebar-gruppe">{gruppe.titel}</li>}
              {gruppe.eintraege.map(item => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className={`sidebar-link${isActive(item.path) ? ' active' : ''}`}
                    onClick={() => setOpen(false)}
                  >
                    <span className="sidebar-icon">{item.icon}</span>
                    {item.label}
                  </Link>
                </li>
              ))}
            </React.Fragment>
          ))}
        </ul>

        <div className="sidebar-footer">
          <div className="sidebar-user">
            <div className="sidebar-user-name">{user?.vorname} {user?.nachname}</div>
            <div className="sidebar-user-role">{user?.rolle}</div>
          </div>
          <button className="sidebar-logout" onClick={handleLogout}>Abmelden</button>
        </div>
      </nav>

      <div className="main-wrapper">
        <header className="topbar">
          <button className="menu-toggle" onClick={() => setOpen(true)} aria-label="Menü öffnen">
            <span /><span /><span />
          </button>
          <h1 className="topbar-title">SwimDesk</h1>
          <GlobaleSuche />
          <div className="topbar-user">{user?.vorname} {user?.nachname}</div>
        </header>
        <main className="page-content">{children}</main>
      </div>
    </div>
  );
}
